<template>
    <div
        :shown="getType(eventType)"    
    >
        <!-- {{ getType(eventType) }} -->
        <icon-form
            :is-icon-form-sidebar-active.sync="isIconFormSidebarActive"
            :icon-data="iconData"
            :type="type"
            @refetch-data="refetchData" 
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateIcon()"
                            >
                                <span class="text-nowrap">Add Icon</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <!-- <b-table>

            </b-table> -->
            <b-table
                ref="refIconListTable"
                :items="icons"
                responsive
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                show-empty
                empty-text="No matching records found"
                :sort-desc.sync="isSortDirDesc"
                class="position-relative"
            >
                <template #cell(path)="data">
                    <b-img
                        :src="data.item.path?data.item.path:require(`@/assets/images/no-image.png`)"
                        height="75"
                        width="75"
                        class="rounded m-0"
                    />
                </template>
                <template #cell(name)="data">
                    {{ data.item.name[currentLocale] }}
                </template>
                <template #cell(is_active)="data">
                    <b-badge
                        pill
                        :variant="`light-${resolveCatagoryStatusVariant(data.item.is_active)}`"
                        class="text-capitalize"
                    >
                        {{ resolveCatagoryStatusnameVariant(data.item.is_active) }} 
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateIcon(data.item)" variant="outline-success">Edit</b-button>
                    <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(data.item.id)" variant="outline-danger">Delete</b-button>
                </template>
            </b-table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalIcons"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue';
    import draggable from 'vuedraggable'
    import { ref,onUnmounted } from '@vue/composition-api'
    import store from '@/store'
    import Ripple from 'vue-ripple-directive';
    import useIconList from './useIconList'
    import IconForm from '../event-form/IconForm.vue'
    import eventStoreModule from '../../eventStoreModule';
    import { FeatherIcon, MenuIcon } from 'vue-feather-icons'

    export default {

        components: {
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BImg,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            IconForm, draggable, MenuIcon
        },
        directives: {
            'b-modal': VBModal,
            Ripple
        },
        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },
        props: {
            eventType: {
                type: String,
                required: true
            },
        },
        setup() {
            const EVENT_STORE_MODULE_NAME = 'app-event';
            if (!store.hasModule(EVENT_STORE_MODULE_NAME)) store.registerModule(EVENT_STORE_MODULE_NAME, eventStoreModule)
            onUnmounted(() => {
                if (store.hasModule(EVENT_STORE_MODULE_NAME)) store.unregisterModule(EVENT_STORE_MODULE_NAME)
            });

            // getType(eventType)

            const {
                isIconFormSidebarActive,
                iconData,
                refetchData,
                tableColumns,
                getCategoryData,
                searchQuery,
                fetchIconData,
                sortBy,
                icons,
                totalIcons,
                refIconListTable,
                resolveCatagoryStatusVariant,
                resolveCatagoryStatusnameVariant,
                updateIcon,
                deleteData,
                isSortDirDesc,
                dataMeta,
                type,
                getType,
                perPage,
                currentPage,
            } = useIconList();

            // fetchCategoryData();

            return {
                isIconFormSidebarActive,
                iconData,
                refetchData,
                tableColumns,
                getCategoryData,
                searchQuery,
                fetchIconData,
                sortBy,
                isSortDirDesc,
                icons,
                totalIcons,
                refIconListTable,
                resolveCatagoryStatusVariant,
                resolveCatagoryStatusnameVariant,
                updateIcon,
                deleteData,
                isSortDirDesc,
                dataMeta,
                type,
                getType,
                perPage,
                currentPage,
            }
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete Food Category ID.'+id, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
</script>